import React, { createContext, useEffect, useReducer, useState } from "react";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import * as types from "./store/types";
import { reducer, defaultState } from "./store";
import { toast } from "react-toastify";
import * as customerStorage from "modules/app/utils/storage/customers";
import * as http from "modules/app/utils/http";

const ContactsStateContext = createContext();
const ContactsDispatchContext = createContext();

const defaultContact = {
  products: [],
  sold_products: [],
  contact: {
    name: null,
    phone: null,
    email: null,
  },
};

function ContactsContext({ contactId, contacts, children }) {
  const [loadingContact, setLoadingContact] = useState(false);
  const [state, dispatch] = useReducer(reducer, defaultState);
  const { t } = useTranslation("Chat");

  function showLoading(contact) {
    dispatch({
      type: types.CURRENT_CONTACT_UPDATE,
      contact: {
        ...contact,
        ...{
          messages: [],
        },
      },
    });
  }

  async function updateCurrentCustomer() {
    const contactFromFirebase = contacts && _.find(contacts, { id: contactId });
    const currentMessages = state?.currentContact?.messages;
    const currentMessagesCount =
      state?.currentContact?.currentContactMessagesCount;
    const finalCustomer = !!contactFromFirebase
      ? contactFromFirebase
      : { ...state?.currentContact };

    if (
      finalCustomer?.messages_count > currentMessagesCount ||
      finalCustomer?.last_message?.ack?.whatsapp?.status !==
        currentMessages[currentMessages.length - 1]?.ack?.whatsapp?.status
    ) {
      const customerResponse = await http.getCustomer(finalCustomer);
      const messagesResponse = await http.getMessages(finalCustomer.id, 1);
      const sortedMessages = messagesResponse.data.reverse();

      dispatch({
        type: types.CURRENT_CONTACT_UPDATE,
        contact: {
          ...customerResponse,
          messages: [...sortedMessages],
          totalPages: Number(messagesResponse?.headers["total-pages"]),
          currentContactMessagesCount: customerResponse?.messages?.length,
          resetPage: true,
        },
      });
    }
  }

  function loadCustomer() {
    const contactFromFirebase = contacts.find(
      (contact) => contact.id === contactId
    );
    const finalCustomer = !!contactFromFirebase
      ? contactFromFirebase
      : { ...defaultContact, id: contactId };

    if (state?.currentContact?.id != contactId) {
      showLoading(defaultContact);
      setLoadingContact(true);
    }

    customerStorage
      .customerProxy(finalCustomer)
      .then((customer) => {
        dispatch({
          type: types.CURRENT_CONTACT_UPDATE,
          contact: customer,
        });
      })
      .catch((e) => {
        if (e?.message != "cancel") {
          toast.error(t("errors.customerNotLoaded"));
          dispatch({ type: types.CURRENT_CONTACT_NULL });
          console.log(e);
        }
      })
      .finally(() => {
        setLoadingContact(false);
      });
  }

  useEffect(() => {
    let mount = true;

    if (mount) {
      updateCurrentCustomer();
    }

    return () => {
      mount = false;
    };
  }, [contacts]);

  useEffect(() => {
    let mount = true;

    if (mount) {
      loadCustomer();
    }

    return () => {
      mount = false;
    };
  }, [contactId]);

  return (
    <ContactsStateContext.Provider value={{ ...state, loadingContact }}>
      <ContactsDispatchContext.Provider value={dispatch}>
        {children}
      </ContactsDispatchContext.Provider>
    </ContactsStateContext.Provider>
  );
}

export { ContactsStateContext, ContactsDispatchContext, ContactsContext };
